import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * Who the new campaign flow acts for — the signed-in brand (or the brand an
 * agency switched into: /switch/user puts that brand's ids on UserReducer).
 *
 * The mobile app reads the same ids off its auth state; these are what the brd
 * API checks against the caller's token (brd-identity.ts), so they must be the
 * brand's own, never 0.
 */
export function useBrandUser() {
  const user = useSelector((state: any) => state?.UserReducer?.UserData) || null;
  return useMemo(() => {
    const u: any = user || {};
    const num = (v: unknown) => {
      const n = Number(v);
      return Number.isFinite(n) && n > 0 ? n : 0;
    };
    const accountType = String(u.account_type || '').toLowerCase() === 'agency' ? 'Agency' : 'Brand';
    return {
      brandId: num(u.brand_id),
      accountId: num(u.account_id),
      userId: num(u.user_id),
      /** The brand's own creator identity: the sender of the brand's messages. */
      influencerId: num(u.influencer_id),
      accountType: accountType as 'Brand' | 'Agency',
      /** Shown on the brief ("Show brand") and used for AI prompts. */
      brandName: String(u.brand_name || u.company_trade_name || u.account_name || '').trim(),
      /** The sender name on the brand's messages (as the app sends it). */
      displayName: String(u.account_name || u.brand_name || '').trim(),
      /** A ClanConnect admin (user_roles.view_admin_dashboard), as the site header decides: sees Admin → Review Campaigns. */
      isAdmin: String(u.view_admin_dashboard) === 'True',
      user: u,
    };
  }, [user]);
}

export type BrandUser = ReturnType<typeof useBrandUser>;
